import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import shallow from "zustand/shallow";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { useGetChannelMessage } from "utils/hooks/useGetChannelMessage";

import { useGetAuthorizationStore } from "./useGetAuthorizationStore";
import { UserAction } from "../application/types/UserAction";

export const useUserActionWatcher = () => {
  //potrzebne do nasłuchiwania zmian w innych zakładkach przeglądarki
  const message = useGetChannelMessage<UserAction>("USER_ACTION");
  const { push, location } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();

  const { setAuthorization, deleteAuthorization } = useGetAuthorizationStore(
    (state) => ({
      setAuthorization: state.setAuthorization,
      deleteAuthorization: state.deleteAuthorization,
    }),
    shallow
  );

  useEffect(() => {
    if (message === UserAction.Logout) {
      if (location.pathname.includes("uzytkownik")) {
        push(`/e-rezerwacja/${friendlyUrl}`);
      }
      deleteAuthorization();
    }
    if (message === UserAction.Login) {
      setAuthorization(localStorage["user-id"], localStorage["token-security"]);
    }
    // eslint-disable-next-line
  }, [deleteAuthorization, friendlyUrl, message, push, setAuthorization]);
};
